import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    let swiper = new Swiper(".gallery-modal-slider", {
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: ".banner-button-next",
            prevEl: ".banner-button-prev",
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerSlider = new Swiper(".banner__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let discountsSlides = document.querySelectorAll(".discounts-slide");

    discountsSlides.forEach(discountSlide => {
        const slide = discountSlide.querySelector(".swiper-container");
        const buttonNext = discountSlide.querySelector(".discounts-button-next");
        const buttonPrev = discountSlide.querySelector(".discounts-button-prev");

        new Swiper(slide, {
            slidesPerView: 3.5,
            spaceBetween: 30,
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                600: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                900: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                1199: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                },
            },
            navigation: {
                nextEl: buttonNext,
                prevEl: buttonPrev,
            },
        });
    });

    let servicesSlider = new Swiper(".services__slider", {
        watchOverflow: true,
        slidesPerView: 3.5,
        spaceBetween: 30,
        navigation: {
            nextEl: ".services-button-next",
            prevEl: ".services-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    });

    let highlightsSlider = new Swiper(".highlights__slider", {
        watchOverflow: true,
        slidesPerView: 3.5,
        spaceBetween: 30,
        navigation: {
            nextEl: ".highlights-button-next",
            prevEl: ".highlights-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    });

    let exploreSlider = new Swiper(".explore__slider", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
            nextEl: ".explore-button-next",
            prevEl: ".explore-button-prev",
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
    });

    let ipdcList = new Swiper(".ipdc__list", {
        watchOverflow: true,
        slidesPerView: 3.5,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1199: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".ipdc-button-next",
            prevEl: ".ipdc-button-prev",
        },
    });

    let othersSlide = new Swiper(".others-slide", {
        slidesPerView: 3.5,
        spaceBetween: 30,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 10,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
        },
        navigation: {
            nextEl: ".others-button-next",
            prevEl: ".others-button-prev",
        },
    });

    let servicesList = new Swiper(".services__list", {
        watchOverflow: true,
        slidesPerView: 3.5,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1199: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".services-button-next",
            prevEl: ".services-button-prev",
        },
    });

    let eventsList = new Swiper(".events__list", {
        watchOverflow: true,
        slidesPerView: 3,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1199: {
                slidesPerView: 3,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".events-button-next",
            prevEl: ".events-button-prev",
        },
    });

    let unitiesSlide = new Swiper(".unities__slide", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 32,
        breakpoints: {
            600: {
                slidesPerView: 1,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            1199: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".unities-button-next",
            prevEl: ".unities-button-prev",
        },
    });
};
